import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import consultedCase from "../../redux/consultedCase";

import ConsultedCases from "../../components/ConsultedCases/ConsultedCases";

const { getConsultedCaseList } = consultedCase.actions;

const mapStateToProps = (state) => {
  const {
    completedCaseListLoading,
    completedCaseList,
    totalCountCompleted,
  } = state[consultedCase.name];
  const { statesList, telemedicineCategoriesList } = state.entities;
  return {
    caseListLoading: completedCaseListLoading,
    consultedCaseList: completedCaseList,
    statesList: statesList,
    telemedicineCategoriesList: telemedicineCategoriesList,
    totalCount: totalCountCompleted,
  };
};
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getConsultedCaseList,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultedCases);
